import { useCallback, useEffect, useState, useRef } from "react";
import { useAppContext } from "utils/context";
import {
  postSubmitAnswer,
  postLastCompleteSurvey,
  postStartSurvey,
  postPreviousQuestion,
} from "containers/services/services";
import RiskBoard from "./board";
import RiskQuestions from "./questions";
import RiskQuestionLoading from "containers/pmaOnboarding/components/loading/questionLoading";

const PmaRiskAssessment = ({
  boardLoading,
  currentStageDetails,
  onFinishRisk,
}) => {
  const { instance } = useAppContext();
  const formRef = useRef();

  const [loading, setLoading] = useState(false);
  const [backLoading, setBackLoading] = useState(false);
  const [nextLoading, setNextLoading] = useState(false);

  const [lastSurveyData, setLastSurveyData] = useState(null);
  const [startSurveyData, setStartSurveyData] = useState(null);

  const surveyId = currentStageDetails?.page_info?.[0]?.infos[0]?.value;

  const handleStartSurvey = async ({ onclose, setStarting }) => {
    const response = await postStartSurvey(instance, surveyId);
    if (response) {
      setLastSurveyData(null);
      setStartSurveyData(response);
    }
    if (onclose) {
      setStarting(false);
      onclose();
    }

    setLoading(false);
  };

  const handleCheckingSurveyStatus = useCallback(async () => {
    setLoading(true);
    const { data: res, error } = await postLastCompleteSurvey(
      instance,
      surveyId
    );
    if (error) return handleStartSurvey({});

    setLastSurveyData(res);
    setLoading(false);
  });

  const handleFinishSubmitAnswer = async (value) => {
    setNextLoading(true);
    const data = {
      question_id: startSurveyData?.question?.id,
      user_survey_id: startSurveyData?.user_survey_id,
      answer_id: value?.answer,
    };
    const response = await postSubmitAnswer(instance, data);

    if (response) {
      formRef.current.resetFields();
      if (response.score) {
        setLastSurveyData(response);
        setStartSurveyData(null);
      } else {
        setStartSurveyData(response);
      }
    }

    setNextLoading(false);
  };

  const handleSubmitPreviousQuestion = async () => {
    setBackLoading(true);
    const response = await postPreviousQuestion(
      instance,
      startSurveyData?.user_survey_id
    );

    if (response) {
      formRef.current.resetFields();
      setStartSurveyData(response);
    }

    setBackLoading(false);
  };

  useEffect(() => {
    handleCheckingSurveyStatus();
  }, []);

  const renderRiskBoard = () => {
    const score = lastSurveyData?.overall_score || lastSurveyData?.score;
    return (
      lastSurveyData &&
      (score > 0 ? (
        <RiskBoard
          score={score}
          loading={boardLoading}
          riskTaking={lastSurveyData?.risk_taking}
          onStartSurvey={handleStartSurvey}
          onFinishRisk={() => onFinishRisk(lastSurveyData)}
        />
      ) : (
        ""
      ))
    );
  };

  const renderRiskQuestions = () =>
    startSurveyData ? (
      <RiskQuestions
        backLoading={backLoading}
        data={startSurveyData}
        disabled={backLoading || nextLoading}
        formRef={formRef}
        nextLoading={nextLoading}
        onSubmitPreviousQuestion={handleSubmitPreviousQuestion}
        onFinishSubmitAnswer={handleFinishSubmitAnswer}
      />
    ) : (
      ""
    );

  return (
    <div className="">
      {loading ? (
        <RiskQuestionLoading />
      ) : (
        <>
          {renderRiskBoard()}
          {renderRiskQuestions()}
        </>
      )}
    </div>
  );
};

export default PmaRiskAssessment;
